import { SBARUIConfig } from "../../../components/ui/SBARUI";
import BaseScenarioPart from "../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../misc/tools";
import { DaarcBaseScenario } from "../../DaarcBaseScenario";
import { BaseGeneralConfig, GeneralPartConfig } from "../general-scenario-stuff";
import { GeneralStepCollection } from "../GeneralStepCollection";
import GeneralIntroPart1 from "./parts/GeneralIntroPart1";
import GeneralIntroPart1CC from "./parts/GeneralIntroPart1CC";

export default class GeneralIntroMain extends GeneralStepCollection {
	private _parts: BaseScenarioPart<DaarcBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: GeneralIntroMainConfig) {
		super();
		var context = this;
		// context._parts.push(new GeneralIntroPart1(context.config.scenario, () => {
		// 	context.config.onDone();
		// }, context._partId1, config));
		context._parts.push(new GeneralIntroPart1CC(context.config.scenario, () => {
			context.config.onDone();
		}, context._partId1, config));
	}

	public start() {
		this.goToStep1();
	}

	goToStep1() {
		this.config.scenario.showDefaultSideMenu();
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface GeneralIntroMainConfig extends BaseGeneralConfig {
	scenario: DaarcBaseScenario;
	part1Config?: GeneralIntroPart1CCConfig;
	onDone: () => void;
}

export interface GeneralIntroPart1Config extends GeneralPartConfig {
	dialogs: GeneralIntroDialog[];
	sbarConfig: SBARUIConfig;
	onSbarClosed?: () => void;
}

export interface GeneralIntroPart1CCConfig extends GeneralPartConfig {
	chapters: GeneralIntroChapters[];
	sbarConfig: SBARUIConfig;
	onSbarClosed?: () => void;
}

export interface GeneralIntroChapters {
	chapterName: () => string;
}

export interface GeneralIntroDialog {
	speakerName: string;
	text: string;
	videoChapter: () => string;
}